import { useState, useEffect } from "react"
import AddAppModal from './AddAppModal';
import { axiosSecureInstance } from "../../api/axios"
import { Button, Spin, Empty } from "antd"
import "./AddApp.css"

const AddApps = ({ onAddApp }) => {
  const [isModalOpen, setModalOpen] = useState(false)
  const [appsIntegrated, setAppsIntegrated] = useState([])
  const [customFields, setCustomFields] = useState([])
  const [applicationsData, setApplicationsData] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  const fetchApps = async () => {
    try {
      setLoading(true)
      setError(null)
      const response = await axiosSecureInstance.get(`${process.env.REACT_APP_BASE_URL}api/get-apps`)
      const apps = response.data.apps.map((app) => ({
        key: app._id,
        name: app.service_name,
        slug: app.slug,
        status: app.is_active ? "Connected" : "Disconnected",
        icon: (
          <img
            src={app.service_icon || "/placeholder.svg"}
            alt={`${app.service_name} Icon`}
            style={{ width: 25, height: 25, marginRight: 9, marginLeft: 0, alignItems: "left" }}
          />
        ),
        isConnected: app.is_active,
      }))
      setApplicationsData(apps)
    } catch (error) {
      setError("Failed to load applications.")
      console.error("Error fetching apps:", error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchApps()
  }, [])

  const handleAddApp = (appName, appIconUrl, fields) => {
    setAppsIntegrated((prevApps) => [...prevApps, { name: appName, iconUrl: appIconUrl, fields }])
    setCustomFields(fields)
    fetchApps()
    onAddApp(appName, appIconUrl, fields)
  }

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  return (
    <div>
      <Button type="primary" onClick={() => setModalOpen(true)} style={{ marginBottom: "16px" }}>
        Add Apps
      </Button>

      {isModalOpen && (
        <AddAppModal
          onAddApp={handleAddApp}
          onClose={handleCloseModal}
          visible={isModalOpen}
        />
      )}
      {/* <IntegrateApps/> */}
    </div>
  );
};

export default AddApps;